import {
  normalizeProtoInt64,
} from '../../identity/helpers/disclosure-scope.helper';

/** Local API shapes (mirrors authentication.proto partner integration messages). */
export type PartnerIntegrationRequest = {
  id?: string;
  submitterUserId?: string;
  status?: string;
  requestedClientId?: string;
  appName?: string;
  providerType?: string;
  redirectUris?: string[];
  scopeIds?: string[];
  environment?: string;
  reviewerNotes?: string;
  reviewedByUserId?: string;
  reviewedAt?: number;
  oauthClientId?: string;
  createdAt?: number;
  updatedAt?: number;
  submittedAt?: number;
  webhookUrl?: string;
  webhookConfigured?: boolean;
};

export type PartnerIntegrationRequestsResponse = {
  items?: PartnerIntegrationRequest[];
};

export type CreatePartnerIntegrationRequestDto = {
  requestedClientId: string;
  appName: string;
  providerType: string;
  redirectUris: string[];
  scopeIds: string[];
  environment: string;
  webhookUrl?: string;
};

export type UpdatePartnerIntegrationRequestDto = {
  requestedClientId: string;
  appName: string;
  providerType: string;
  redirectUris: string[];
  scopeIds: string[];
  environment: string;
  webhookUrl?: string;
};

export type PartnerWebhookSecretResponse = {
  webhookUrl?: string;
  webhookSecret?: string;
  webhookConfigured?: boolean;
};

export type PartnerWebhookDelivery = {
  id?: string;
  oauthClientId?: string;
  eventType?: string;
  grantId?: string;
  subjectUserId?: string;
  webhookUrl?: string;
  payloadJson?: string;
  httpStatus?: number;
  delivered?: boolean;
  errorMessage?: string;
  resentFromId?: string;
  createdAt?: number;
};

export type PartnerWebhookDeliveriesResponse = {
  items?: PartnerWebhookDelivery[];
};

export type ReviewPartnerIntegrationRequestDto = {
  reviewerNotes?: string;
};

export type DossierScopeCatalogResponse = {
  catalogVersion?: string;
  items?: Array<{
    scopeId?: string;
    label?: string;
    sensitivity?: string;
    dossierPaths?: string[];
  }>;
};

export const PARTNER_PROVIDER_TYPES = ['roblox', 'discord', 'custom'] as const;
export type PartnerProviderType = (typeof PARTNER_PROVIDER_TYPES)[number];

export const INTEGRATION_ENVIRONMENTS = ['sandbox', 'production'] as const;
export type IntegrationEnvironment = (typeof INTEGRATION_ENVIRONMENTS)[number];

export function normalizeIntegrationRequestsResponse(
  response: PartnerIntegrationRequestsResponse | null | undefined,
): PartnerIntegrationRequest[] {
  const items = Array.isArray(response?.items) ? response.items : [];
  return items.map((item) => ({
    ...item,
    createdAt: normalizeOptionalUnix(item.createdAt),
    updatedAt: normalizeOptionalUnix(item.updatedAt),
    submittedAt: normalizeOptionalUnix(item.submittedAt),
    reviewedAt: normalizeOptionalUnix(item.reviewedAt),
  }));
}

function normalizeOptionalUnix(value: unknown): number | undefined {
  const unixSeconds = normalizeProtoInt64(value);
  return unixSeconds > 0 ? unixSeconds : undefined;
}

export function isIntegrationEditable(status: string | undefined): boolean {
  return status === 'draft' || status === 'needs_info';
}

export function isIntegrationSubmittable(status: string | undefined): boolean {
  return status === 'draft' || status === 'needs_info';
}
